"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ParentAccountBalanceAdjustmentType;
(function (ParentAccountBalanceAdjustmentType) {
    ParentAccountBalanceAdjustmentType[ParentAccountBalanceAdjustmentType["SetBalance"] = 0] = "SetBalance";
    ParentAccountBalanceAdjustmentType[ParentAccountBalanceAdjustmentType["Credit"] = 1] = "Credit";
    ParentAccountBalanceAdjustmentType[ParentAccountBalanceAdjustmentType["Debit"] = 2] = "Debit";
})(ParentAccountBalanceAdjustmentType || (ParentAccountBalanceAdjustmentType = {}));
exports.default = ParentAccountBalanceAdjustmentType;
